import { IFieldForm } from "pages/read-documents/model/IFieldForm";

type IFieldFormCostCenter = IFieldForm & {
  required?: boolean;
  maxLength?: number;
};

export const fieldsFormCostCenter = (): IFieldForm[] => {
  return [
    {
      id: "itemFormCodigoCentroCostos",
      name: "codigoCentroCostos",
      type: "text",
      label: "Código centro de costos",
      placeholder: "Ingrese código centro de costos",
      testId: "itemFormCodigoCentroCostos",
      isEnable: true,
    },
    {
      id: "itemFormCodigoConcepto",
      name: "codigoConcepto",
      type: "text",
      label: "Código concepto",
      placeholder: "Ingrese código concepto",
      testId: "itemFormCodigoConcepto",
      isEnable: true,
    },
  ];
};

export const fieldsFormCreateCostCenter = (
  stateOptions: any[] = [],
): IFieldFormCostCenter[] => {
  return [
    {
      id: "itemFormCodigoCentroCostosCreate",
      name: "codigoCentroCostos",
      type: "text",
      label: "Código centro de costos",
      placeholder: "Ingrese código centro de costos",
      testId: "itemFormCodigoCentroCostosCreate",
      isEnable: true,
      required: true,
      maxLength: 30,
    },
    {
      id: "itemFormNombreCreate",
      name: "nombre",
      type: "text",
      label: "Nombre",
      placeholder: "Ingrese nombre",
      testId: "itemFormNombreCreate",
      isEnable: true,
      required: true,
      maxLength: 100,
    },
    {
      id: "itemFormDescripcionActividadProyectoCreate",
      name: "descripcionActividadProyecto",
      type: "text",
      label: "Descripción",
      placeholder: "Ingrese descripción",
      testId: "itemFormDescripcionActividadProyectoCreate",
      isEnable: true,
      required: true,
      maxLength: 300,
    },
    {
      id: "itemFormCodigoConceptoCreate",
      name: "codigoConcepto",
      type: "text",
      label: "Código concepto",
      placeholder: "Ingrese código concepto",
      testId: "itemFormCodigoConceptoCreate",
      isEnable: true,
      required: true,
      maxLength: 30,
    },
    {
      id: "itemFormCuentaContableCreate",
      name: "cuentaContable",
      type: "text",
      label: "Cuenta contable",
      placeholder: "Ingrese cuenta contable",
      testId: "itemFormCuentaContableCreate",
      isEnable: true,
      required: true,
      maxLength: 30,
    },
    {
      id: "itemFormFuenteFinanciacionCreate",
      name: "fuenteFinanciacion",
      type: "text",
      label: "Fuente financiación",
      placeholder: "Ingrese fuente financiación",
      testId: "itemFormFuenteFinanciacionCreate",
      isEnable: true,
      required: true,
      maxLength: 50,
    },
    {
      id: "itemFormInicioVigenciaCreate",
      name: "inicioVigencia",
      type: "date",
      label: "Inicio vigencia",
      placeholder: "Ingrese inicio vigencia",
      testId: "itemFormInicioVigenciaCreate",
      isEnable: true,
      required: true,
    },
    {
      id: "itemFormFinVigenciaCreate",
      name: "finVigencia",
      type: "date",
      label: "Fin vigencia",
      placeholder: "Ingrese fin vigencia",
      testId: "itemFormFinVigenciaCreate",
      isEnable: true,
      required: true,
    },
    {
      id: "itemFormEstadoCreate",
      name: "estado",
      type: "select",
      label: "Estado",
      placeholder: "Seleccione estado",
      testId: "itemFormEstadoCreate",
      isEnable: true,
      required: true,
      options: stateOptions,
    },
  ];
};
